import { useAuth } from "@/context/AuthContext";
import AdminDashboard from "@/pages/AdminDashboard";
import CollabDashboard from "@/pages/CollabDashboard";

export default function Dashboard() {
  const { isAdmin } = useAuth();
  return isAdmin ? <AdminDashboard /> : <CollabDashboard />;
}
